module.exports = __webpack_public_path__ + "img/shield-e.f9ad49c0.png";